import React, { useState, useEffect } from 'react';
import { DivTag } from '../../../Components/Tags/Tags';
import Header from '../../../Components/Header';
import Seo from '../../../Components/SeoComponent/Seo';
import { HeadTag, InputField } from '../../../Components/Tags/Tags';
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils';
import GaugeChart from 'react-gauge-chart';
import { checkTransUnionReport3 } from '../../../Services/EquifaxCScore/highmark';
import TransUnionReportModal3 from './TransUnionReport';
import html2pdf from 'html2pdf.js';
import Loader from '../../../Loader';
import {TransUnionData3,equifaxDataError} from "./data";
import { fetchProfile } from '../../../Services/profile/profileservice';

const TransUnionScore3 = () => {
  const [cusName, setCusName] = useState('');
  const [mobile, setMobile] = useState('');
  const [panNo, setPanNo] = useState('');
  const [gender, setGender] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditScore, setCreditScore] = useState(0);
 // const [creditScore, setCreditScore] = useState(TransUnionData3.data.GetCustomerAssetsResponse.GetCustomerAssetsSuccess.Asset.TrueLinkCreditReport.Borrower.CreditScore.riskScore);
  const [isModalOpen, setModalOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [TransUnionReport, setTransUnionReport] = useState(null);
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null);
  const [submittedName, setSubmittedName] = useState('');
  const [submittedMobile, setSubmittedMobile] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const maxScore = 900;

  const validateForm = () => {
    const newErrors = {};

    // Validate customer name
    if (!cusName || cusName.trim() === '') {
      newErrors.cusName = 'Name is required.';
    }

    // Validate mobile
    if (!mobile || mobile === '') {
      newErrors.mobile = 'Mobile number is required.';
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number.';
    }

    // Validate gender
    if (!gender || gender === '') {
      newErrors.gender = 'Gender is required.';
    }

    // Validate PAN
    if (!panNo || panNo === '') {
      newErrors.panNo = 'PAN number is required.';
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase())) {
      newErrors.panNo = 'Enter a valid PAN number (e.g., ABCDE1234F).';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      showErrorToast('Please fix the validation errors.');
      return;
    }

    await TransUnion3();
  };

  const handleDownloadPDF = () => {
    setIsDownloading(true);

    setTimeout(() => {
      const element = document.getElementById('reportdata');
      const name = TransUnionReport?.name || Equifaxv2Error?.data?.name || Equifaxv2Error?.error?.name || 'N/A';

      if (element) {
        element.classList.remove('hidden');

        const clonedElement = element.cloneNode(true);

        clonedElement.style.margin = '0';
        clonedElement.style.padding = '0';
        clonedElement.style.position = 'relative';
        clonedElement.style.top = '0';
        clonedElement.style.left = '0';
        clonedElement.style.maxHeight = 'none';
        clonedElement.style.overflow = 'visible';
        clonedElement.style.width = '100%';

        clonedElement.querySelectorAll('.hidden').forEach((child) => {
          child.classList.remove('hidden');
        });

        clonedElement.querySelectorAll('.no-print').forEach((child) => {
          child.style.display = 'none';
        });

        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.top = '0';
        tempDiv.style.left = '0';
        tempDiv.style.width = '100%';
        tempDiv.style.visibility = 'hidden';
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);

        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: 'TransUnion_Credit_Report_' + name + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, backgroundColor: 'white' },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add('hidden');
            setIsDownloading(false);
            showSuccessToast('PDF downloaded successfully!');
          })
          .catch((error) => {
            console.error('PDF generation error:', error);
            showErrorToast('Failed to generate PDF');
            document.body.removeChild(tempDiv);
            element.classList.add('hidden');
            setIsDownloading(false);
          });
      } else {
        showErrorToast('No data found to download');
        setIsDownloading(false);
      }
    }, 10);
  };




async function TransUnion3() {
  try {
    setShowLoader(true);
    setIsLoading(true);

    const payload = {
      api_id: profileData?.user_id,
      api_key: profileData?.api_key,
      token_id: profileData?.token_id,
      mobile: mobile,
      name: cusName,
      gender: gender,
      pan: panNo.toUpperCase(),
      consent: 'Y',
    };

  //  console.log('TransUnion V3 Payload:', payload);
    const response = await checkTransUnionReport3(payload);
   // console.log('TransUnion V3 Response:', response);

    // Handle specific known errors first (keep your existing handlers)
    if (response.status === 403 && response.data?.message === 'Invalid or deactivated API key.') {
      setShowLoader(false);
      setIsLoading(false);
      showErrorToast('Invalid or deactivated API key.');
      return;
    }

    if (response.status === 422 && response.data?.message === 'Insufficient balance in api user wallet.') {
      setShowLoader(false);
      setIsLoading(false);
      showErrorToast('Insufficient balance in wallet.');
      return;
    }

        if (response.status === 422 && response.data?.message === 'Your service is not available in this environment.') {
      setShowLoader(false);
      setIsLoading(false);
      showErrorToast('Your service is not available in this environment.');
      return;
    }

    if (response.status === 422 && response.data?.message === 'User not authorized to access this service.') {
      setShowLoader(false);
      setIsLoading(false);
      showErrorToast('User not authorized to access this service.');
      return;
    }

    // Check for the specific 500 "No credit history" error
    if (response.status === 500 || 
        (response.data?.status?.code === 500) ||
        (response.data?.status?.message === 'No credit history found for the provided details.')) {
      setTransUnionReport(null);
      setShowLoader(false);
      setIsLoading(false);
      showErrorToast('No credit history found for the provided details.');
      setEquifaxv2Error(response?.error || response?.data || response?.data?.status || {});
    //  console.log("error msg",Equifaxv2Error); 
      return;
    }

    // Success condition: Check nested status.code === 200 OR has the credit report data structure
    const isSuccess = 
      (response?.status?.code === 200) ||
      (response?.data?.status?.code === 200) ||
      (response.data || response.data?.data) ||
      response.data?.GetCustomerAssetsResponse?.GetCustomerAssetsSuccess?.Asset?.TrueLinkCreditReport;

    if (isSuccess) {
      setTransUnionReport(response);
     // console.log("t data",TransUnionReport)

      const score = 
        response.data?.GetCustomerAssetsResponse?.GetCustomerAssetsSuccess?.Asset?.TrueLinkCreditReport?.Borrower?.CreditScore?.riskScore ||
        0;
      
      setCreditScore(score);
     // console.log("sc", creditScore);
      setSubmittedName(cusName);
      setSubmittedMobile(mobile);

      setCusName('');
      setMobile('');
      setPanNo('');
      setGender('');
      setErrors({});

      setShowLoader(false);
      setIsLoading(false);
      showSuccessToast(response.message || 'Credit report fetched successfully!');

      // setModalOpen(true);
      return;
    } else {
      // All other error cases
        setEquifaxv2Error(response?.error || response?.data || response?.data?.status || {}); 
     
      setTransUnionReport(null);
      setShowLoader(false);
      setIsLoading(false);

      showErrorToast(
        response?.data?.status?.message ||
        response?.data?.message ||
        response?.message ||
        response?.data?.error?.credit_report_message?.message ||
        response?.error?.message ||
        response?.data?.error ||
        'Something went wrong.'
      );
       console.log("error msg else",Equifaxv2Error);
    }
  } catch (error) {
    console.error('Error in TransUnion V3:', error);
    setTransUnionReport(null);
    setShowLoader(false);
    setIsLoading(false);
    showErrorToast('Something went wrong. Please try again.');
  }
}



  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error('Error fetching profile data:', error);
        showErrorToast('Failed to fetch profile data');
      }
    }
    fetchProfileData();
  }, []);

  const getAccountSummary = () => {
    const summary = TransUnionReport?.credit_report?.[0]?.response?.consumerSummaryresp?.accountSummary;
    return {
      totalAccounts: summary?.totalAccounts || 'N/A',
      currentBalance: summary?.currentBalance ? '₹' + parseFloat(summary.currentBalance).toLocaleString('en-IN') : 'N/A',
      overdueAccounts: summary?.overdueAccounts || 'N/A',
      overdueBalance: summary?.overdueBalance ? '₹' + parseFloat(summary.overdueBalance).toLocaleString('en-IN') : 'N/A',
      zeroBalanceAccounts: summary?.zeroBalanceAccounts || 'N/A',
    };
  };

  const accountSummary = getAccountSummary();
  const displayName = TransUnionReport?.name || Equifaxv2Error?.data?.name || Equifaxv2Error?.error?.name || submittedName;

  return (
    <React.Fragment>
      <Seo />
      {showLoader && <Loader />}

      <Header heading="TransUnion (CIBIL) V3 Credit Report" />

      <DivTag className="container grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-2 p-4 bg-white mt-2 shadow-lg shadow-blue-600 rounded-md">
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="cus_name"
            name="cus_name"
            value={cusName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter Name"
            onChange={(e) => setCusName(e.target.value)}
          />
          {errors.cusName && <p className="text-red-600 text-sm font-mono mt-1">{errors.cusName}</p>}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            PAN<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="pan_no"
            name="pan_no"
            value={panNo}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 uppercase"
            placeholder="Enter PAN"
            onChange={(e) => setPanNo(e.target.value.toUpperCase())}
            maxLength={10}
          />
          {errors.panNo && <p className="text-red-600 text-sm font-mono mt-1">{errors.panNo}</p>}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Gender<strong className="text-red-700">*</strong>
          </HeadTag>
          <select
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          {errors.gender && <p className="text-red-600 text-sm font-mono mt-1">{errors.gender}</p>}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif">
            Mobile<strong className="text-red-700">*</strong>
          </HeadTag>
          <InputField
            type="text"
            placeholder="Enter Mobile"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
            name="mobile"
            id="mobile"
            value={mobile}
            onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
            maxLength={10}
          />
          {errors.mobile && <p className="text-red-600 text-sm font-mono mt-1">{errors.mobile}</p>}
        </DivTag>

        <DivTag className="flex flex-col justify-end">
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
          >
            {isLoading ? 'Loading...' : 'Submit'}
          </button>
        </DivTag>
      </DivTag>

      {(TransUnionReport || Equifaxv2Error) && (
        <div className="flex flex-col p-4 bg-white shadow-inner mt-4 shadow-blue-600 rounded-md">
          <span className="text-center font-bold md:text-xl">Hey {displayName}!</span>
          <h2 className="text-xl md:text-2xl font-semibold text-center mt-2">Your TransUnion Credit Score</h2>

          <div className="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 mt-4 relative">
            <div className="w-full md:w-[400px] relative">
              <span className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70 top-[60px] left-5">
                Poor
              </span>
              <span className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26 left-[69px] top-[-7px]">
                Average
              </span>
              <span className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20 left-[12rem] mt-[-9px] rotate-20">
                Good
              </span>
              <span className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70 ml-[16rem] mt-[3.5rem]">
                Excellent
              </span>

              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={3}
                percent={creditScore / maxScore}
                needleColor={'#00008b'}
                textColor={'transparent'}
                needleBaseColor={'red'}
                arcsLength={[0.3, 0.3, 0.3, 0.3]}
                colors={['#cc0000', '#e6e600', '#cc6600', '#009900']}
              />
              <p className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] left-1/2 transform -translate-x-1/2">
                {creditScore}
              </p>
            </div>

            <div className="flex flex-col items-center md:items-start">
              {/* <ul className="text-left text-sm md:text-base space-y-2 mt-4">
                <li>
                  <span className="font-bold">No of Accounts: </span>
                  <span className="text-gray-700">{accountSummary.totalAccounts}</span>
                </li>
                <li>
                  <span className="font-bold">Total Balance Amount: </span>
                  <span className="text-gray-700">{accountSummary.currentBalance}</span>
                </li>
                <li>
                  <span className="font-bold">Total Overdue Accounts: </span>
                  <span className="text-red-600 font-semibold">{accountSummary.overdueAccounts}</span>
                </li>
                <li>
                  <span className="font-bold">Total Overdue Balance: </span>
                  <span className="text-red-600 font-semibold">{accountSummary.overdueBalance}</span>
                </li>
                <li>
                  <span className="font-bold">Total Zero Balance Account: </span>
                  <span className="text-green-600 font-semibold">{accountSummary.zeroBalanceAccounts}</span>
                </li>
              </ul> */}

              <TransUnionReportModal3
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                CreditReportData={TransUnionReport}
                Equifaxv2Error={Equifaxv2Error}
                cusName={cusName}
                panNo={panNo}
                mobile={mobile}
                gender={gender}
                displayMessageBlock={true}
              />

              <div className="flex space-x-2 mt-4">
                <button
                  onClick={() => setModalOpen(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-base rounded-md px-4 py-2 transition-colors shadow-md"
                >
                  View Details
                </button>
                {/* <button
                  className="bg-red-600 hover:bg-red-700 text-white text-sm md:text-base rounded-md px-4 py-2 transition-colors shadow-md"
                  onClick={handleDownloadPDF}
                  disabled={isDownloading}
                >
                  {isDownloading ? 'Downloading...' : 'Download PDF'}
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-center mt-6 mb-6">
        <div className="flex flex-col items-center bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg shadow-xl shadow-blue-800 md:w-3/4 w-full p-6">
          <h1 className="font-bold text-2xl md:text-3xl text-red-600 underline mb-3">Instructions</h1>
          <h2 className="text-lg md:text-xl font-bold text-center text-gray-800 mb-4 underline">
            How to get Best Financial Credit Report in TransUnion (CIBIL) V3?
          </h2>

          <ul className="list-decimal list-inside text-left text-gray-700 space-y-2 text-sm md:text-base">
            <li>Enter the correct <strong>Name</strong> and <strong>Gender</strong>.</li>
            <li>Enter the <strong>Mobile Number</strong> which is registered with the credit bureau company.</li>
            <li>Enter the correct <strong>PAN Number</strong> (10 characters - 5 letters, 4 digits, 1 letter).</li>
            <li>The TransUnion (CIBIL) credit report only provides details of consumers available in the TransUnion (CIBIL) Bureau database.</li>
            <li>If you don't receive a report, try with different details or check another bureau company.</li>
            <li>Ensure all details match exactly with your credit bureau records for accurate results.</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TransUnionScore3;
